import { PureComponent } from 'react';

import CoreUtils from '../utils/CoreUtils';

import DataItem from '../model/DataItem';

export default class DataItemView extends PureComponent {
  static displayName = DataItemView.name;

  constructor(props) {
    super(props);

    this.dataItemStateListener = this.dataItemStateUpdated.bind(this);
    this.dataItem = null;
    this.propertyNames = [];
    this.isViewMounted = false;
    this.state = {
      isDataBound: false
    };
  }

  componentDidMount() {
    this.isViewMounted = true;
  }

  componentWillUnmount() {
    this.unbindDataItem();
    this.isViewMounted = false;
  }

  dataItemDidBind(dataItem) { }
  dataItemWillUnbind(dataItem) { }

  bindDataItem(dataItem) {
    if (dataItem === this.dataItem)
      return;

    this.unbindDataItem();

    if (CoreUtils.isUndefinedOrNull(dataItem) || !(dataItem instanceof DataItem))
      return;

    this.dataItem = dataItem;
    this.dataItem.addStateListener(this.dataItemStateListener);

    var state = this.dataItem.getState();
    this.scanPropertyNames(state);
    state.isDataBound = true;

    if (this.isViewMounted)
      this.setState(state)
    else {
      if (CoreUtils.isUndefinedOrNull(this.state))
        this.state = state;
      else
        Object.assign(this.state, state);
    }

    this.dataItemDidBind(this.dataItem);
  }

  unbindDataItem() {
    if (this.dataItem === null)
      return;

    this.dataItemWillUnbind(this.dataItem);

    this.clearPropertyNames();
    this.dataItem.removeStateListener(this.dataItemStateListener);
    this.dataItem = null;
  }

  dataItemStateUpdated(state) {
    this.scanPropertyNames(state);
    this.setState(state);
  }

  scanPropertyNames(state) {
    CoreUtils.getObjectPropertyNames(state)
      .forEach(propertyName => {
        if (this.propertyNames.indexOf(propertyName) === -1)
          this.propertyNames.push(propertyName);
      });
  }

  clearPropertyNames() {
    var state = {};

    this.propertyNames.forEach(
      propertyName => state[propertyName] = undefined
    );

    state.isDataBound = false;
    this.setState(state);
    this.propertyNames = [];
  }
}